

import {CHANGE_PAGE, LOAD_TOP_WORDS_PAGINATED, SEARCH_CHANGE} from "./full-report-top-words-action-types";

export const changePage = ({next, previous}) => ({ type: CHANGE_PAGE, next, previous});
export const loadTopWordsPaginated = topWordsPaginated => ({ type: LOAD_TOP_WORDS_PAGINATED, topWordsPaginated});
export const searchChange = searchValue => ({ type: SEARCH_CHANGE, searchValue });


// WEBPACK FOOTER //
// ./src/modules/full-report-top-words/full-report-top-words-action-creators.js